import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {isMobile} from 'react-device-detect';
import {dataUsageWarningTooltipData} from '../productsAndServicesBlockSlice';

const DataUsageAlertPopup = (props) => {
  return (
    <div className={`${isMobile ? 'isMobile pr-0 pl-0' : ''}`}>
      <div>
        <Image src={require('../images/bell.svg')} alt='alert' />
      </div>
      <div className='semiBold main-text d-block w-100'>{dataUsageWarningTooltipData.title}</div>
      <div className='w-100 description'>{dataUsageWarningTooltipData.text}</div>
    </div>
  );
};
export default DataUsageAlertPopup;
